import { render } from "./page-revise.vue?vue&type=template&id=9f079516&lang=html"
import script from "./page-revise.vue?vue&type=script&lang=js"
export * from "./page-revise.vue?vue&type=script&lang=js"
script.render = render

export default script